import { type OpenApiSchemaPromocodeGroup } from '#shared/api/schema';
import { type PromoactionModel } from '../types';

const MAX_USAGE_LIMIT_DEFAULT_VALUE = 1;

export const mapPromoactionToPromocode = (promoaction: PromoactionModel): OpenApiSchemaPromocodeGroup => {
    const { discount, validity, mode, applicability, meta } = promoaction;

    const isPercent = discount.type === 'percent';

    return {
        id: promoaction.id ?? promoaction.mode.promocodeGroupId,
        title: promoaction.title,
        group_type: mode.promocodeGroupType,
        type: meta.type === 'on_orders' ? 'ORDER' : 'PRODUCTS',
        applicability_type: applicability.type,
        applied_category_ids:
            applicability.type === 'CATEGORIES_AND_COLLECTIONS' ? applicability.appliedCategoryIds : undefined,
        applied_collection_ids:
            applicability.type === 'CATEGORIES_AND_COLLECTIONS' ? applicability.appliedCollectionIds : undefined,
        applied_product_list_id:
            applicability.type === 'PRODUCT_LIST' && applicability.appliedProductListId
                ? applicability.appliedProductListId
                : undefined,
        discount_type: discount.type,
        discount_value: isPercent ? discount.value_percent : discount.value_fixed,
        minimum_order_amount: discount.minimum_order_amount || null,
        max_discount_amount: isPercent && discount.max_discount_amount ? Number(discount.max_discount_amount) : null,
        max_usage: validity.maxUsageLimit === 'true' ? MAX_USAGE_LIMIT_DEFAULT_VALUE : null,
        one_time_use: validity.isOneTimeUse === 'true',
        first_order_only: validity.isFirstOrderOnly === 'true',
        valid_from: validity.validFrom,
        valid_until: validity.validUntil === '' ? undefined : validity.validUntil,
        status: meta.status,
        deactivated: meta.deactivated,
        usage_count: meta.usageCount,
        code_count: mode.codeCount ?? 0,
        created_at: meta.createdAt,
        show_in_pdp: promoaction.showInPdp === 'true',
        updated_at: meta.updatedAt,
    };
};
